import { RouteRecordRaw } from 'vue-router'

const authRoutes: Array<RouteRecordRaw> = [
  {
    path: '/silentRenew',
    name: 'silentRenew',
    component: () => import('../views/auth/SilentRenew.vue'),
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('../views/auth/Callback.vue'),
  },
  // {
  //     path: "/accept-invitation",
  //     name: "AcceptInvitation",
  //     component: () => import("../views/AcceptInvitation.vue")
  // },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/auth/Logout.vue'),
  },
  {
    path: '/signout-callback',
    name: 'signoutCallback',
    component: () => import('../views/auth/LogoutCallback.vue'),
  },
  {
    path: '/registration-callback',
    name: 'registrationCallback',
    component: () => import('../views/auth/RegistrationCallback.vue'),
  },
  {
    path: '/delete-account-callback',
    name: 'deleteAccountCallback',
    component: () => import('../views/auth/DeleteAccountCallback.vue'),
  },
]

export default authRoutes
